<template>
  <v-img contain height="18px" width="18px" src="@/assets/tiktok-svgrepo-com.svg"></v-img>
</template>

<script>
export default {
  name: 'TiktokLogoIcon'
//   props: {
//     imgsrc: String
//   }
}
</script>
